import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import Layout from '../components/Layout';
import { siteContent } from '../data/siteContent';
import { useTranslation } from '../context/TranslationContext';
import SEO from '../components/SEO';
import { PAGE_SEO } from '../data/seoMeta';

function ToneRegistryPage() {
  var t = useTranslation().t;
  var appStoreUrl = siteContent.toneRegistry.appStoreUrl;
  var features = [
    t('toneRegistryFeature1'),
    t('toneRegistryFeature2'),
    t('toneRegistryFeature3'),
    t('toneRegistryFeature4')
  ];

  return (
    <Layout>
      <SEO title={PAGE_SEO['toneregistry'].title} description={PAGE_SEO['toneregistry'].description} url="/toneregistry" />
      <section className="relative min-h-screen flex items-center pt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-[#d4af37]/10 via-black to-black" />
        
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <span className="inline-block px-4 py-2 rounded-full bg-[#d4af37]/10 text-[#d4af37] text-sm font-semibold mb-6">
                {t('toneRegistryIOSApp')}
              </span>
              <h1 className="text-5xl md:text-7xl font-bold text-white mb-6">
                ToneRegistry
              </h1>
              <p className="text-2xl text-neutral-300 mb-4">
                {t('toneRegistryTagline')}
              </p>
              <p className="text-lg text-neutral-500 mb-10 leading-relaxed">
                {t('toneRegistryDescription')}
              </p>

              <div className="flex flex-wrap items-center gap-6">
                <a
                  href={appStoreUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="toneregistry-appstore-btn"
                  className="inline-block"
                >
                  <img
                    src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                    alt="Download on the App Store"
                    className="h-16 hover:opacity-80 transition-opacity"
                  />
                </a>
                <div className="text-neutral-500">
                  <p className="text-sm">{t('toneRegistryAndroidVersion')}</p>
                  <p className="text-[#d4af37] font-medium">{t('toneRegistryComingSoon')}</p>
                </div>
              </div>
            </div>

            <div className="flex justify-center">
              <div className="relative">
                <div className="absolute -inset-8 bg-[#d4af37]/20 rounded-full blur-3xl" />
                <img 
                  src="https://customer-assets.emergentagent.com/job_trumpet-innovations/artifacts/5i8r6bbt_Simulator%20Screenshot%20-%20iPhone%2017%20-%202025-12-25%20at%2001.04.46.png" 
                  alt="ToneRegistry App" 
                  className="relative w-72 h-auto object-contain rounded-[3rem]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-24 bg-neutral-950">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <p className="text-sm tracking-widest uppercase text-[#d4af37] mb-4">{t('toneRegistryFeaturesLabel')}</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white">
              {t('toneRegistryEverythingYouNeed')}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map(function(feature, index) {
              return (
                <div
                  key={index}
                  className="p-6 rounded-2xl bg-black border border-white/5 hover:border-[#d4af37]/30 transition-all"
                >
                  <div className="w-12 h-12 rounded-xl bg-[#d4af37]/10 flex items-center justify-center mb-4">
                    <Check className="w-6 h-6 text-[#d4af37]" />
                  </div>
                  <h3 className="text-lg font-semibold text-white">{feature}</h3>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-24 bg-black">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">{t('toneRegistryReadyToProtect')}</h2>
          <p className="text-neutral-400 mb-10">
            {t('toneRegistryDownloadCta')}
          </p>
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#d4af37] text-black hover:bg-white px-8 py-4 rounded-full font-semibold transition-all"
          >
            {t('toneRegistryDownloadFree')}
            <ArrowRight className="w-5 h-5" />
          </a>
        </div>
      </section>
    </Layout>
  );
}

export default ToneRegistryPage;
